import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";
import { Box, Button, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
import { getAllUsersData } from "./utility/getAllUsersData";
import { getAllFirstDayAnswerData } from "./utility/getAllFirstDayANswerData";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { UserProgressDashBoard } from "./adminComponents/UserProgressDashBoard";
import { getAllMetaData } from "./utility/getAllMetaData";
import { GetFirstDayAnswerDataComponent } from "./adminComponents/GetFIrstDayAnswerDataComponent";
import { GetAllAnswerDataComponent } from "./adminComponents/GetAllAnswerDataComponent";
import { getOpenAIAssistantConversation } from "./utility/getOpenAIAssistantConversation";
import { getAllConversationData } from "./utility/getAllConversationData";
import { ChatRestorationComponent } from "./adminComponents/ChatRestorationComponent";
import { GetAllConversationDataComponent } from "./adminComponents/GetAllConvarsationDataComponent";
import { getAllAnswerData } from "./utility/getAllAnswerData";

interface MergedStartDayData {
  email: string;
  userLastModifiedDate: string;
  startDate: string;
  lastImplementationDate: string;
  implementationCount: number;
}

export const AdminPage = () => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const { idToken, refreshAuthSession } = useAuth();

  const [mergedStartDayData, setMergedStartDayData] = useState<
    MergedStartDayData[]
  >([]);

  const [isProgress, setIsProgress] = useState<boolean>(false);

  useEffect(() => {
    if (idToken) {
      try {
        const decodedToken: any = jwtDecode(idToken);
        const userGroups = decodedToken["cognito:groups"] || [];
        setIsAdmin(userGroups.includes("Admin"));
      } catch (error) {
        console.error("Token decode error:", error);
      }
    }
  }, [idToken]);

  const mergeUserAndAnswerData = (
    userData: any,
    answerData: any,
    capitalData: any
  ): MergedStartDayData[] => {
    const answerMap = new Map<string, string>();
    const capitalMap = new Map<string, { lastDate: string; count: number }>();

    // answerDataから最初のdateを取得してMapに格納
    if (answerData?.data) {
      answerData.data.forEach((answer: any) => {
        if (!answerMap.has(answer.userId)) {
          answerMap.set(answer.userId, answer.date);
        }
      });
    }

    // capitalDataから最新の日付と実施回数を取得
    if (capitalData?.data) {
      capitalData.data.forEach((capital: any) => {
        const userId = capital.userId;
        const date = capital.date;

        if (capitalMap.has(userId)) {
          const existing = capitalMap.get(userId)!;
          // より新しい日付があれば更新
          if (date > existing.lastDate) {
            existing.lastDate = date;
          }
          existing.count += 1;
        } else {
          capitalMap.set(userId, { lastDate: date, count: 1 });
        }
      });
    }

    // userDataとanswerData、capitalDataをマージ
    const result: MergedStartDayData[] = [];
    if (userData?.users) {
      userData.users.forEach((user: any) => {
        const email = user.attributes?.email || "";
        const userLastModifiedDate = user.userLastModifiedDate || "";
        const date = answerMap.get(user.username) || "";
        const capitalInfo = capitalMap.get(user.username);

        result.push({
          email,
          userLastModifiedDate,
          startDate: date,
          lastImplementationDate: capitalInfo?.lastDate || "",
          implementationCount: capitalInfo?.count || 0,
        });
      });
    }

    return result;
  };

  const getProgressData = async () => {
    if (idToken) {
      setIsProgress(true);
      const userData = await getAllUsersData(idToken);
      const answerData = await getAllFirstDayAnswerData(idToken);
      const capitalData = await getAllMetaData(idToken);
      console.log(answerData);
      const mergedData = mergeUserAndAnswerData(
        userData,
        answerData,
        capitalData
      );
      setMergedStartDayData(mergedData);
      setIsProgress(false);
    }
  };

  const testFunc = () => {
    if (!idToken) return;
    getAllAnswerData(idToken).then((data) => {
      console.log(data);
    });
  };

  if (!isAdmin) {
    return (
      <Box sx={{ p: 2 }}>
        <Box sx={{ p: 1 }}>
          <Button onClick={() => navigate("/")}>
            <ArrowBackIosIcon fontSize="small" />
            戻る
          </Button>
        </Box>
        <Typography>アクセス権がありません</Typography>
        {/* <Button onClick={getStartDayData}>TEST</Button> */}
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Typography variant="h5">管理者ページ</Typography>
        <Box sx={{ height: "3rem" }}></Box>
        <Typography>参加者情報の取得</Typography>
        <Box sx={{ m: 2 }}>
          <Button variant="contained" onClick={getProgressData}>
            参加者情報を取得
          </Button>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Typography>データの取得</Typography>
          <Box sx={{ m: 2 }}>
            <GetFirstDayAnswerDataComponent setIsProgress={setIsProgress} />
          </Box>
          <Box sx={{ m: 2 }}>
            <GetAllAnswerDataComponent setIsProgress={setIsProgress} />
          </Box>
          <Box sx={{ m: 2 }}>
            <GetAllConversationDataComponent />
          </Box>
          {/* <Box sx={{ m: 2 }}>
            <ChatRestorationComponent />
          </Box> */}
        </Box>
        {/* <Button onClick={testFunc}>test</Button> */}
      </Box>

      {isProgress && <Typography sx={{ m: 1 }}>データ取得中...</Typography>}
      {mergedStartDayData.length > 0 && (
        <UserProgressDashBoard mergedStartDayData={mergedStartDayData} />
      )}

      {/* <Button onClick={testFunc}>TEST</Button> */}
    </>
  );
};
